import React from 'react';
import { GetServerSideProps } from 'next';
import HomeBlog, { HomeBlogProps } from 'components/Blog/HomeBlog';
import { getAllBlogsByPage } from 'components/Blog/blogApi';

interface BlogQueryParams extends Record<string, any> {
  slug: string;
}

function BlogHome(blogData: HomeBlogProps) {
  return (
    <HomeBlog
      categories={blogData.categories}
      posts={blogData.posts}
      contributors={blogData.contributors}
      webStories={blogData.webStories}
    />
  );
}

export const getServerSideProps: GetServerSideProps<HomeBlogProps, BlogQueryParams> = async () => {
  const blogData = await getAllBlogsByPage(0);
  const blogs = blogData.posts;
  const contributors = blogData.contributors;
  const webStories = blogData.webStories;
  const categories = blogData.categories;
  if (blogData) {
    return {
      props: {
        posts: blogs,
        contributors,
        webStories,
        categories,
      },
    };
  } else {
    return {
      notFound: true,
    };
  }
};

export default BlogHome;
